import React from 'react';
import { useParams } from 'react-router-dom';
import CommonHeader from '../../Components/Headers/CommonHeader.jsx';
import { BlogPostDetails } from '../../Components/Blog/BlogPostDetails.jsx';
import SummaryBlog from '../../Components/Blog/SummaryBlog.jsx';
import Footer from '../../Components/Home/Footer.jsx';

export default function PostPage({ post }) {
  return (
    <React.Fragment>
      <CommonHeader />
      <div className="row p-4">
        <div className="col-12 col-md-2 order-0 order-md-0 mb-4 mb-md-0">
          <SummaryBlog />
        </div>
        <div className="col-12 col-md-8 order-1 order-md-1">
          <BlogPostDetails post={post} />
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
}
